document.addEventListener('DOMContentLoaded', () => {
  const { referrer } = document;
  const { href: currentUrl } = window.location;
  const mainContentDiv = document.querySelector('.Page-inner');

  if (referrer && referrer.substring(0, referrer.lastIndexOf('/')) === currentUrl.substring(0, currentUrl.lastIndexOf('/'))) {
    if (mainContentDiv) {
      mainContentDiv.scrollIntoView({ behavior: 'smooth' });
    }
  }
});
